import { useId } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'
import classNames from 'classnames'
import { LayoutGroup } from 'framer-motion'
import _ from 'lodash'

import * as styles from './index.vanilla.css'

interface Props {
  min: number
  max: number
  value?: number | null | undefined
  onClick?: (value: number) => void
  readonly?: boolean
  mandatory?: boolean
  hasTooltip?: boolean
  tooltipLabel?: string
  'aria-labelledby'?: string
  onHover?: (hoveredRating: number) => void
  missingLabel?: string
  error?: string
}

const Rating = (props: Props) => {
  const {
    min,
    max,
    value,
    onClick,
    readonly,
    mandatory,
    tooltipLabel,
    onHover,
    'aria-labelledby': ariaLabelledBy,
    missingLabel,
    error,
  } = props

  const errorDescription = error || missingLabel
  const errorContent = (
    <Box aria-label={errorDescription}>
      <Icon.Small icon="alert" encircled={error ? 'radicalRed1000' : 'grey800'} />
    </Box>
  )

  const onClickButton = (event: React.SyntheticEvent<HTMLElement>, r: number) => {
    event.preventDefault()
    onClick && onClick(r)
  }

  const layoutGroupId = useId()

  const handleMouseEnter = (r: number) => {
    onHover && onHover(r)
  }

  return (
    <Box gap="s4">
      <Box flexDirection="row" gap="s8" role="group" aria-labelledby={ariaLabelledBy} width="full">
        <LayoutGroup id={layoutGroupId}>
          {_.range(min, max + 1).map((r) => {
            const checked = r === value

            const ratingContent = <div>{r}</div>

            return (
              <button
                className={classNames(styles.item, {
                  [styles.checkedItem]: checked,
                  [styles.readonlyItem]: readonly,
                  [styles.readonlyCheck]: checked && readonly,
                  [styles.errorItem]: !!error,
                })}
                disabled={readonly}
                key={r}
                onClick={(event) => onClickButton(event, r)}
                onMouseEnter={() => {
                  handleMouseEnter(r)
                }}
                aria-pressed={checked}
              >
                {tooltipLabel ? (
                  <Tooltip instant description={tooltipLabel}>
                    {ratingContent}
                  </Tooltip>
                ) : (
                  ratingContent
                )}
              </button>
            )
          })}
          {(mandatory || error) && (
            <Box paddingLeft="s8">
              {errorDescription ? (
                <Tooltip description={errorDescription}>{errorContent}</Tooltip>
              ) : (
                errorContent
              )}
            </Box>
          )}
        </LayoutGroup>
      </Box>
      {error && (
        <Text.Normal size="200" color="radicalRed1000">
          {error}
        </Text.Normal>
      )}
    </Box>
  )
}

export default Rating
